module.exports = __webpack_public_path__ + "media/home-video-hd.56e7bf43.mp4";